import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class KeyCode {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "None": return 0;
        case "Backspace": return 8;
        case "Tab": return 9;
        case "Clear": return 12;
        case "Return": return 13;
        case "Pause": return 19;
        case "Escape": return 27;
        case "Space": return 32;
        case "Exclaim": return 33;
        case "DoubleQuote": return 34;
        case "Hash": return 35;
        case "Dollar": return 36;
        case "Percent": return 37;
        case "Ampersand": return 38;
        case "Quote": return 39;
        case "LeftParen": return 40;
        case "RightParen": return 41;
        case "Asterisk": return 42;
        case "Plus": return 43;
        case "Comma": return 44;
        case "Minus": return 45;
        case "Period": return 46;
        case "Slash": return 47;
        case "Alpha0": return 48;
        case "Alpha1": return 49;
        case "Alpha2": return 50;
        case "Alpha3": return 51;
        case "Alpha4": return 52;
        case "Alpha5": return 53;
        case "Alpha6": return 54;
        case "Alpha7": return 55;
        case "Alpha8": return 56;
        case "Alpha9": return 57;
        case "Colon": return 58;
        case "Semicolon": return 59;
        case "Less": return 60;
        case "Equals": return 61;
        case "Greater": return 62;
        case "Question": return 63;
        case "At": return 64;
        case "LeftBracket": return 91;
        case "Backslash": return 92;
        case "RightBracket": return 93;
        case "Caret": return 94;
        case "Underscore": return 95;
        case "BackQuote": return 96;
        case "A": return 97;
        case "B": return 98;
        case "C": return 99;
        case "D": return 100;
        case "E": return 101;
        case "F": return 102;
        case "G": return 103;
        case "H": return 104;
        case "I": return 105;
        case "J": return 106;
        case "K": return 107;
        case "L": return 108;
        case "M": return 109;
        case "N": return 110;
        case "O": return 111;
        case "P": return 112;
        case "Q": return 113;
        case "R": return 114;
        case "S": return 115;
        case "T": return 116;
        case "U": return 117;
        case "V": return 118;
        case "W": return 119;
        case "X": return 120;
        case "Y": return 121;
        case "Z": return 122;
        case "LeftCurlyBracket": return 123;
        case "Pipe": return 124;
        case "RightCurlyBracket": return 125;
        case "Tilde": return 126;
        case "Delete": return 127;
        case "Keypad0": return 256;
        case "Keypad1": return 257;
        case "Keypad2": return 258;
        case "Keypad3": return 259;
        case "Keypad4": return 260;
        case "Keypad5": return 261;
        case "Keypad6": return 262;
        case "Keypad7": return 263;
        case "Keypad8": return 264;
        case "Keypad9": return 265;
        case "KeypadPeriod": return 266;
        case "KeypadDivide": return 267;
        case "KeypadMultiply": return 268;
        case "KeypadMinus": return 269;
        case "KeypadPlus": return 270;
        case "KeypadEnter": return 271;
        case "KeypadEquals": return 272;
        case "UpArrow": return 273;
        case "DownArrow": return 274;
        case "RightArrow": return 275;
        case "LeftArrow": return 276;
        case "Insert": return 277;
        case "Home": return 278;
        case "End": return 279;
        case "PageUp": return 280;
        case "PageDown": return 281;
        case "F1": return 282;
        case "F2": return 283;
        case "F3": return 284;
        case "F4": return 285;
        case "F5": return 286;
        case "F6": return 287;
        case "F7": return 288;
        case "F8": return 289;
        case "F9": return 290;
        case "F10": return 291;
        case "F11": return 292;
        case "F12": return 293;
        case "F13": return 294;
        case "F14": return 295;
        case "F15": return 296;
        case "Numlock": return 300;
        case "CapsLock": return 301;
        case "ScrollLock": return 302;
        case "RightShift": return 303;
        case "LeftShift": return 304;
        case "RightControl": return 305;
        case "LeftControl": return 306;
        case "RightAlt": return 307;
        case "LeftAlt": return 308;
        case "RightCommand": return 309;
        case "LeftCommand": return 310;
        case "LeftWindows": return 311;
        case "RightWindows": return 312;
        case "AltGr": return 313;
        case "Help": return 315;
        case "Print": return 316;
        case "SysReq": return 317;
        case "Break": return 318;
        case "Menu": return 319;
        case "Mouse0": return 323;
        case "Mouse1": return 324;
        case "Mouse2": return 325;
        case "Mouse3": return 326;
        case "Mouse4": return 327;
        case "Mouse5": return 328;
        case "Mouse6": return 329;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return KeyCode.fromJson(value);
  }
  static fromReact(e) {
    return KeyCode.fromJson(e);
  }
}
KeyCode.None = 0;
KeyCode.Backspace = 8;
KeyCode.Tab = 9;
KeyCode.Clear = 12;
KeyCode.Return = 13;
KeyCode.Pause = 19;
KeyCode.Escape = 27;
KeyCode.Space = 32;
KeyCode.Exclaim = 33;
KeyCode.DoubleQuote = 34;
KeyCode.Hash = 35;
KeyCode.Dollar = 36;
KeyCode.Percent = 37;
KeyCode.Ampersand = 38;
KeyCode.Quote = 39;
KeyCode.LeftParen = 40;
KeyCode.RightParen = 41;
KeyCode.Asterisk = 42;
KeyCode.Plus = 43;
KeyCode.Comma = 44;
KeyCode.Minus = 45;
KeyCode.Period = 46;
KeyCode.Slash = 47;
KeyCode.Alpha0 = 48;
KeyCode.Alpha1 = 49;
KeyCode.Alpha2 = 50;
KeyCode.Alpha3 = 51;
KeyCode.Alpha4 = 52;
KeyCode.Alpha5 = 53;
KeyCode.Alpha6 = 54;
KeyCode.Alpha7 = 55;
KeyCode.Alpha8 = 56;
KeyCode.Alpha9 = 57;
KeyCode.Colon = 58;
KeyCode.Semicolon = 59;
KeyCode.Less = 60;
KeyCode.Equals = 61;
KeyCode.Greater = 62;
KeyCode.Question = 63;
KeyCode.At = 64;
KeyCode.LeftBracket = 91;
KeyCode.Backslash = 92;
KeyCode.RightBracket = 93;
KeyCode.Caret = 94;
KeyCode.Underscore = 95;
KeyCode.BackQuote = 96;
KeyCode.A = 97;
KeyCode.B = 98;
KeyCode.C = 99;
KeyCode.D = 100;
KeyCode.E = 101;
KeyCode.F = 102;
KeyCode.G = 103;
KeyCode.H = 104;
KeyCode.I = 105;
KeyCode.J = 106;
KeyCode.K = 107;
KeyCode.L = 108;
KeyCode.M = 109;
KeyCode.N = 110;
KeyCode.O = 111;
KeyCode.P = 112;
KeyCode.Q = 113;
KeyCode.R = 114;
KeyCode.S = 115;
KeyCode.T = 116;
KeyCode.U = 117;
KeyCode.V = 118;
KeyCode.W = 119;
KeyCode.X = 120;
KeyCode.Y = 121;
KeyCode.Z = 122;
KeyCode.LeftCurlyBracket = 123;
KeyCode.Pipe = 124;
KeyCode.RightCurlyBracket = 125;
KeyCode.Tilde = 126;
KeyCode.Delete = 127;
KeyCode.Keypad0 = 256;
KeyCode.Keypad1 = 257;
KeyCode.Keypad2 = 258;
KeyCode.Keypad3 = 259;
KeyCode.Keypad4 = 260;
KeyCode.Keypad5 = 261;
KeyCode.Keypad6 = 262;
KeyCode.Keypad7 = 263;
KeyCode.Keypad8 = 264;
KeyCode.Keypad9 = 265;
KeyCode.KeypadPeriod = 266;
KeyCode.KeypadDivide = 267;
KeyCode.KeypadMultiply = 268;
KeyCode.KeypadMinus = 269;
KeyCode.KeypadPlus = 270;
KeyCode.KeypadEnter = 271;
KeyCode.KeypadEquals = 272;
KeyCode.UpArrow = 273;
KeyCode.DownArrow = 274;
KeyCode.RightArrow = 275;
KeyCode.LeftArrow = 276;
KeyCode.Insert = 277;
KeyCode.Home = 278;
KeyCode.End = 279;
KeyCode.PageUp = 280;
KeyCode.PageDown = 281;
KeyCode.F1 = 282;
KeyCode.F2 = 283;
KeyCode.F3 = 284;
KeyCode.F4 = 285;
KeyCode.F5 = 286;
KeyCode.F6 = 287;
KeyCode.F7 = 288;
KeyCode.F8 = 289;
KeyCode.F9 = 290;
KeyCode.F10 = 291;
KeyCode.F11 = 292;
KeyCode.F12 = 293;
KeyCode.F13 = 294;
KeyCode.F14 = 295;
KeyCode.F15 = 296;
KeyCode.Numlock = 300;
KeyCode.CapsLock = 301;
KeyCode.ScrollLock = 302;
KeyCode.RightShift = 303;
KeyCode.LeftShift = 304;
KeyCode.RightControl = 305;
KeyCode.LeftControl = 306;
KeyCode.RightAlt = 307;
KeyCode.LeftAlt = 308;
KeyCode.RightCommand = 309;
KeyCode.LeftCommand = 310;
KeyCode.LeftWindows = 311;
KeyCode.RightWindows = 312;
KeyCode.AltGr = 313;
KeyCode.Help = 315;
KeyCode.Print = 316;
KeyCode.SysReq = 317;
KeyCode.Break = 318;
KeyCode.Menu = 319;
KeyCode.Mouse0 = 323;
KeyCode.Mouse1 = 324;
KeyCode.Mouse2 = 325;
KeyCode.Mouse3 = 326;
KeyCode.Mouse4 = 327;
KeyCode.Mouse5 = 328;
KeyCode.Mouse6 = 329;
KeyCode.default = 0;
KeyCode.values = {
  None: 0,
  Backspace: 8,
  Tab: 9,
  Clear: 12,
  Return: 13,
  Pause: 19,
  Escape: 27,
  Space: 32,
  Exclaim: 33,
  DoubleQuote: 34,
  Hash: 35,
  Dollar: 36,
  Percent: 37,
  Ampersand: 38,
  Quote: 39,
  LeftParen: 40,
  RightParen: 41,
  Asterisk: 42,
  Plus: 43,
  Comma: 44,
  Minus: 45,
  Period: 46,
  Slash: 47,
  Alpha0: 48,
  Alpha1: 49,
  Alpha2: 50,
  Alpha3: 51,
  Alpha4: 52,
  Alpha5: 53,
  Alpha6: 54,
  Alpha7: 55,
  Alpha8: 56,
  Alpha9: 57,
  Colon: 58,
  Semicolon: 59,
  Less: 60,
  Equals: 61,
  Greater: 62,
  Question: 63,
  At: 64,
  LeftBracket: 91,
  Backslash: 92,
  RightBracket: 93,
  Caret: 94,
  Underscore: 95,
  BackQuote: 96,
  A: 97,
  B: 98,
  C: 99,
  D: 100,
  E: 101,
  F: 102,
  G: 103,
  H: 104,
  I: 105,
  J: 106,
  K: 107,
  L: 108,
  M: 109,
  N: 110,
  O: 111,
  P: 112,
  Q: 113,
  R: 114,
  S: 115,
  T: 116,
  U: 117,
  V: 118,
  W: 119,
  X: 120,
  Y: 121,
  Z: 122,
  LeftCurlyBracket: 123,
  Pipe: 124,
  RightCurlyBracket: 125,
  Tilde: 126,
  Delete: 127,
  Keypad0: 256,
  Keypad1: 257,
  Keypad2: 258,
  Keypad3: 259,
  Keypad4: 260,
  Keypad5: 261,
  Keypad6: 262,
  Keypad7: 263,
  Keypad8: 264,
  Keypad9: 265,
  KeypadPeriod: 266,
  KeypadDivide: 267,
  KeypadMultiply: 268,
  KeypadMinus: 269,
  KeypadPlus: 270,
  KeypadEnter: 271,
  KeypadEquals: 272,
  UpArrow: 273,
  DownArrow: 274,
  RightArrow: 275,
  LeftArrow: 276,
  Insert: 277,
  Home: 278,
  End: 279,
  PageUp: 280,
  PageDown: 281,
  F1: 282,
  F2: 283,
  F3: 284,
  F4: 285,
  F5: 286,
  F6: 287,
  F7: 288,
  F8: 289,
  F9: 290,
  F10: 291,
  F11: 292,
  F12: 293,
  F13: 294,
  F14: 295,
  F15: 296,
  Numlock: 300,
  CapsLock: 301,
  ScrollLock: 302,
  RightShift: 303,
  LeftShift: 304,
  RightControl: 305,
  LeftControl: 306,
  RightAlt: 307,
  LeftAlt: 308,
  RightCommand: 309,
  LeftCommand: 310,
  LeftWindows: 311,
  RightWindows: 312,
  AltGr: 313,
  Help: 315,
  Print: 316,
  SysReq: 317,
  Break: 318,
  Menu: 319,
  Mouse0: 323,
  Mouse1: 324,
  Mouse2: 325,
  Mouse3: 326,
  Mouse4: 327,
  Mouse5: 328,
  Mouse6: 329,
};
KeyCode.names = {
  0: "None",
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Return",
  19: "Pause",
  27: "Escape",
  32: "Space",
  33: "Exclaim",
  34: "DoubleQuote",
  35: "Hash",
  36: "Dollar",
  37: "Percent",
  38: "Ampersand",
  39: "Quote",
  40: "LeftParen",
  41: "RightParen",
  42: "Asterisk",
  43: "Plus",
  44: "Comma",
  45: "Minus",
  46: "Period",
  47: "Slash",
  48: "Alpha0",
  49: "Alpha1",
  50: "Alpha2",
  51: "Alpha3",
  52: "Alpha4",
  53: "Alpha5",
  54: "Alpha6",
  55: "Alpha7",
  56: "Alpha8",
  57: "Alpha9",
  58: "Colon",
  59: "Semicolon",
  60: "Less",
  61: "Equals",
  62: "Greater",
  63: "Question",
  64: "At",
  91: "LeftBracket",
  92: "Backslash",
  93: "RightBracket",
  94: "Caret",
  95: "Underscore",
  96: "BackQuote",
  97: "A",
  98: "B",
  99: "C",
  100: "D",
  101: "E",
  102: "F",
  103: "G",
  104: "H",
  105: "I",
  106: "J",
  107: "K",
  108: "L",
  109: "M",
  110: "N",
  111: "O",
  112: "P",
  113: "Q",
  114: "R",
  115: "S",
  116: "T",
  117: "U",
  118: "V",
  119: "W",
  120: "X",
  121: "Y",
  122: "Z",
  123: "LeftCurlyBracket",
  124: "Pipe",
  125: "RightCurlyBracket",
  126: "Tilde",
  127: "Delete",
  256: "Keypad0",
  257: "Keypad1",
  258: "Keypad2",
  259: "Keypad3",
  260: "Keypad4",
  261: "Keypad5",
  262: "Keypad6",
  263: "Keypad7",
  264: "Keypad8",
  265: "Keypad9",
  266: "KeypadPeriod",
  267: "KeypadDivide",
  268: "KeypadMultiply",
  269: "KeypadMinus",
  270: "KeypadPlus",
  271: "KeypadEnter",
  272: "KeypadEquals",
  273: "UpArrow",
  274: "DownArrow",
  275: "RightArrow",
  276: "LeftArrow",
  277: "Insert",
  278: "Home",
  279: "End",
  280: "PageUp",
  281: "PageDown",
  282: "F1",
  283: "F2",
  284: "F3",
  285: "F4",
  286: "F5",
  287: "F6",
  288: "F7",
  289: "F8",
  290: "F9",
  291: "F10",
  292: "F11",
  293: "F12",
  294: "F13",
  295: "F14",
  296: "F15",
  300: "Numlock",
  301: "CapsLock",
  302: "ScrollLock",
  303: "RightShift",
  304: "LeftShift",
  305: "RightControl",
  306: "LeftControl",
  307: "RightAlt",
  308: "LeftAlt",
  309: "RightCommand",
  310: "LeftCommand",
  311: "LeftWindows",
  312: "RightWindows",
  313: "AltGr",
  315: "Help",
  316: "Print",
  317: "SysReq",
  318: "Break",
  319: "Menu",
  323: "Mouse0",
  324: "Mouse1",
  325: "Mouse2",
  326: "Mouse3",
  327: "Mouse4",
  328: "Mouse5",
  329: "Mouse6",
};
